import apiClient from './api';

export default {
    async getUsers() {
        const response = await apiClient.get('/users');
        return response.data;
    },

    async createUser(userData) {
        // Default password as per request
        const data = {
            ...userData,
            password: 'sundava2026',
            must_change_password: true
        };
        const response = await apiClient.post('/users', data);
        return response.data;
    },

    async updatePermissions(userId, perms) {
        const response = await apiClient.put(`/users/${userId}/permissions`, perms);
        return response.data;
    },

    async deleteUser(userId) {
        const response = await apiClient.delete(`/users/${userId}`);
        return response.data;
    }
};
